var _g, _text, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReelUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2555",
    "data-name": "Rectangle 2555",
    fill: "#fff",
    stroke: "#21827f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 7.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Reel_upload",
    "data-name": "Reel upload",
    transform: "translate(19 64.785)",
    fill: "#21827f",
    fontSize: 10,
    fontFamily: "Tajawal-Light, Tajawal",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reel upload"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "photo-film-solid_1_",
    "data-name": "photo-film-solid (1)",
    d: "M16.213,0H36.48a4.057,4.057,0,0,1,4.053,4.053V18.24a4.057,4.057,0,0,1-4.053,4.053H16.213A4.057,4.057,0,0,1,12.16,18.24V4.053A4.057,4.057,0,0,1,16.213,0ZM30.146,6.758a1.523,1.523,0,0,0-2.533,0l-3.547,5.32-1.1-1.374a1.515,1.515,0,0,0-2.369,0L16.549,15.77a1.52,1.52,0,0,0,1.184,2.47H34.96a1.52,1.52,0,0,0,1.267-2.362l-6.08-9.12ZM21.28,6.08a2.027,2.027,0,1,0-2.027,2.027A2.027,2.027,0,0,0,21.28,6.08ZM4.053,8.107h6.08v18.24a2.024,2.024,0,0,0,2.027,2.027h8.107a2.024,2.024,0,0,0,2.027-2.027V24.32H32.426v4.053a4.057,4.057,0,0,1-4.053,4.053H4.053A4.057,4.057,0,0,1,0,28.373V12.16A4.057,4.057,0,0,1,4.053,8.107ZM4.56,12.16a1.016,1.016,0,0,0-1.013,1.013v1.013A1.016,1.016,0,0,0,4.56,15.2H5.573a1.016,1.016,0,0,0,1.013-1.013V13.173A1.016,1.016,0,0,0,5.573,12.16Zm0,6.587A1.016,1.016,0,0,0,3.547,19.76v1.013A1.016,1.016,0,0,0,4.56,21.786H5.573a1.016,1.016,0,0,0,1.013-1.013V19.76a1.016,1.016,0,0,0-1.013-1.013Zm0,6.587a1.016,1.016,0,0,0-1.013,1.013V27.36A1.016,1.016,0,0,0,4.56,28.373H5.573A1.016,1.016,0,0,0,6.587,27.36V26.346a1.016,1.016,0,0,0-1.013-1.013Zm21.28,1.013V27.36a1.016,1.016,0,0,0,1.013,1.013h1.013A1.016,1.016,0,0,0,28.88,27.36V26.346a1.016,1.016,0,0,0-1.013-1.013H26.853A1.016,1.016,0,0,0,25.84,26.346Z",
    transform: "translate(22 15.215)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelUpload);
export default __webpack_public_path__ + "static/media/reel-upload.e819375d040604fe2703f4630bb37a20.svg";
export { ForwardRef as ReactComponent };